export type BoostMode = 'queue' | 'direct'

export async function triggerBoostWarnings(opts: { mode?: BoostMode; max?: number; concurrency?: number } = {}): Promise<{ ok: boolean }> {
  const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL as string
  const anon = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY as string
  if (!supabaseUrl || !anon) throw new Error('Supabase URL/Anon key não configurados')
  const { supabase } = await import('@/lib/supabase')
  const session = await supabase.auth.getSession()
  const token = session.data.session?.access_token || anon

  const mode = opts.mode || 'queue'
  const max = typeof opts.max === 'number' ? opts.max : 60
  const concurrency = typeof opts.concurrency === 'number' ? opts.concurrency : 1

  const url = new URL(`${supabaseUrl.replace(/\/$/, '')}/functions/v1/boost-warnings`)
  url.searchParams.set('mode', mode)
  url.searchParams.set('max', String(max))
  url.searchParams.set('concurrency', String(concurrency))

  const res = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, apikey: anon },
  })
  if (!res.ok) throw new Error(await res.text())
  return { ok: true }
}

